import { createAction, props } from '@ngrx/store';

export const updateLoggedState = createAction('[HEADER] Update Logged Flag State', props<{ data: boolean }>());
export const refreshToken = createAction('[HEADER] Refresh Token');
export const languageChanged = createAction('[HEADER] Language Changed', props<{ lang: string }>());
